import axios from "axios";
import { useEffect, useReducer } from "react";
import { xs_languageCode, systemCode } from "../..";
import { dataFetchReducer } from "../utils/dataFetchReducer";
import { getConfiguration } from '../utils/configuration';

export async function fetchSelfList(sessionToken, successCallback, errorCallback) {
    const url = getConfiguration().api['shop.getWorkingSelfList'];
    const params = {
        systemCode,
        lingua: xs_languageCode,
        hash: '',
        sessionToken: sessionToken
    }
    try{
	    const response = await axios.post(url, null, {params});
	    if (!response || response === '') {
            errorCallback();
        }
        else{
        	const list = response.data.code === 0? response.data.object : null;
        	if(list){
	        	successCallback(list);        	
        	}
        	else{
        		errorCallback();
        	}
        }
    }
    catch(e){
        console.error(e);
    	errorCallback();
    }
}

export function useFetchSelfTicketHistory(sessionToken, physicalClientId, shouldExecute, reload) {
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    
    useEffect(() => {
        if (!shouldExecute) {
            return;
        }
        
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };
		const conf = getConfiguration();
        const url = conf.api['shop.getSelfTicketHistory'];
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            sessionToken,
            physicalClientId
        }
        fetchData(url, params, function(response) {
            if (response == null || response === '') {
                dispatch({ type: 'FETCH_FAILURE' });
            }
            dispatch({ type: 'FETCH_SUCCESS', payload: response });
        });
        
        return () => {
            didCancel = true;
        };
    }, [sessionToken, physicalClientId, shouldExecute, reload]);

    return [state, dispatch];
}